import { render, staticRenderFns } from "./member_photo.vue?vue&type=template&id=b6c96d18&"
import script from "./member_photo.vue?vue&type=script&lang=js&"
export * from "./member_photo.vue?vue&type=script&lang=js&"
import style0 from "./member_photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports